import { defineStore } from 'pinia'

import type { IAccount } from '@/types/login'

import { fetchLogin, fetchRoleMenus, fetchUserInfo } from '@/service/login/login'
import { localCache } from '@/utils/cache'
import router from '@/router'
import { mapMenuToRoute } from '@/utils/map/mapMenuToRoute'
import useMainStore from './main/main'
import { mapMenuToPermission } from '@/utils/map/mapMenuToPermission'
import useAnalysisStore from './analysis/analysis'

// 定义类型

interface ILoginState {
  token: string
  userInfo: any
  roleMenus: any[]
  permissions: string[]
}

const useLoginStore = defineStore('login', {
  state: (): ILoginState => ({
    token: '',
    userInfo: {},
    roleMenus: [],
    permissions: []
  }),
  actions: {
    /* 用户登录 */
    async fetchLoginAction(account: IAccount) {
      // 用户登录
      const res = await fetchLogin(account)
      this.token = res.data.token
      localCache.setCache('token', res.data.token)

      // 获取用户详情
      const resUserInfo = await fetchUserInfo(res.data.id)
      this.userInfo = resUserInfo
      localCache.setCache('userInfo', resUserInfo.data)

      // 获取角色菜单树
      const resRoleMenus = await fetchRoleMenus(resUserInfo.data.role.id)
      this.roleMenus = resRoleMenus.data
      localCache.setCache('roleMenus', resRoleMenus.data)

      // 获取整个角色、部门列表
      const mainStore = useMainStore()
      mainStore.getEntireDataListAction()

      // 请求统计数据
      const analysisStore = useAnalysisStore()
      analysisStore.getGoodsAmountListAction()
      analysisStore.getGoodsCategoryCountAction()
      analysisStore.getGoodsCategorySaleAction()
      analysisStore.getGoodsCategoryFavorAction()
      analysisStore.getGoodsAddressSaleAction()

      // 获取按钮权限列表
      console.log(res.data.token)
      const permissions = mapMenuToPermission(this.roleMenus)
      this.permissions = permissions

      // 根据菜单生成动态路由
      const routes = mapMenuToRoute(resRoleMenus.data)
      routes.forEach((route) => router.addRoute('main', route))

      // 跳转首页
      router.push('/main')
    },

    /* 刷新时加载本地缓存，同时生成动态路由 */
    loadLocalAndGenerateRoute() {
      // 当处于登录页时，直接返回
      // const path = window.location.hash
      // if (path.startsWith('#/login')) return

      // 加载本地缓存
      this.token = localCache.getCache('token')
      this.userInfo = localCache.getCache('userInfo')
      this.roleMenus = localCache.getCache('roleMenus')

      if (this.token && this.userInfo && this.roleMenus) {
        // 获取整个角色、部门列表
        const mainStore = useMainStore()
        mainStore.getEntireDataListAction()

        // 请求统计数据
        const analysisStore = useAnalysisStore()
        analysisStore.getGoodsAmountListAction()
        analysisStore.getGoodsCategoryCountAction()
        analysisStore.getGoodsCategorySaleAction()
        analysisStore.getGoodsCategoryFavorAction()
        analysisStore.getGoodsAddressSaleAction()

        // 获取按钮权限列表
        const permissions = mapMenuToPermission(this.roleMenus)
        this.permissions = permissions

        // 生成动态路由
        const routes = mapMenuToRoute(this.roleMenus)
        routes.forEach((item) => router.addRoute('main', item))
      }
    }
  }
})

export default useLoginStore
